import S from './styles';

const Highlight = (props) => {
  const { offsetKey, children } = props;

  return <S.Highlighted data-offset-key={offsetKey}>{children}</S.Highlighted>;
};

export default Highlight;
